import React, { FunctionComponent, useEffect, useState } from "react";
import { Checkbox } from "antd";
import { ShockType } from "./context";
import LineChart from "./chart/line";

import cx from "classnames";
import styles from "./shakeLine.module.less";

interface IProps {
  id: string;
  title: string;
  dataSource: ShockType;
  visibleKeys: string[];
}

const chartColorArr = ["#2fa7ff", "#ffa31f", "#ff5656", "#6ec847", "#914EE3"];

const ShakeLine: FunctionComponent<IProps> = ({ id, title, dataSource, visibleKeys }) => {
  const [active, setActive] = useState<boolean>(false);
  const [chartData, setChartData] = useState<any[]>([]);
  const [checkedArr, setCheckedArr] = useState<any[]>([]);
  const [flag, setFlag] = useState<boolean>(false);

  const onChange = (e: any, parentName: string, modalName: string, data: number[]) => {
    const isCheck = e.target.checked;
    const name = `${parentName}-${modalName}`;
    const info = {
      name,
      type: "line",
      stack: "Total",
      data,
    };

    let copy = [...chartData];

    if (isCheck) {
      copy.push(info);
      setCheckedArr((prev) => prev.concat(name));
    } else {
      copy = copy.filter((item) => item.name !== name);
      setCheckedArr([...checkedArr].filter((item) => item !== name));
    }

    setChartData(copy);
  };

  useEffect(() => {
    console.log(visibleKeys);
    if (visibleKeys.includes(id) && !flag) {
      setFlag(true);
    }
  }, [visibleKeys]);

  useEffect(() => {
    if (dataSource.shock.length !== 0 && dataSource.shock[0].list.length !== 0 && flag) {
      const data = dataSource.shock[0].list[0];
      setChartData([
        {
          name: `${dataSource.shock[0].modelName}-${data.name}`,
          type: "line",
          stack: "Total",
          data: data.data,
        },
      ]);
      setCheckedArr([`${dataSource.shock[0].modelName}-${data.name}`]);
    }
  }, [dataSource, flag]);

  return (
    <div className={styles["shake-line"]}>
      <div className={styles["title"]}>{title}</div>
      <div className={styles["content"]}>
        <div className={cx(styles["select-box"])}>
          <div className={cx(styles["select-titles"])}>
            {dataSource.shock.map((item, inx) => (
              <div className={styles["select-title"]} style={{ backgroundColor: `${chartColorArr[inx]}CC` }} key={inx}>
                {item.modelName}
              </div>
            ))}
          </div>
          <div className={cx(styles["select-checkbox"], { [styles["hide"]]: active })}>
            {dataSource.shock.map((item, inx) => (
              <div className={styles["select-inner"]} key={inx}>
                {item.list.map((i, index) => (
                  <div className={styles["check"]} key={index}>
                    <div className={styles["check-box"]}>
                      <Checkbox
                        checked={checkedArr.includes(`${item.modelName}-${i.name}`)}
                        onChange={(e) => onChange(e, item.modelName, i.name, i.data)}
                      ></Checkbox>
                    </div>
                    {i.name}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className={styles["chart"]} style={{ width: "786px" }}>
          <LineChart id={id} width={786} height={340} dataSource={chartData} />
        </div>
        <div
          className={cx(styles["footer-select"], { [styles["active"]]: active })}
          onClick={() => setActive((prev) => !prev)}
        >
          選擇對比曲線
        </div>
      </div>
    </div>
  );
};

export default ShakeLine;
